define("ember-cp-validations/validators/presence", ["exports", "ember-cp-validations/-private/ember-validator"], function (_exports, _emberValidator) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  /**
   *  <i class="fa fa-hand-o-right" aria-hidden="true"></i> [See All Options](#method_validate)
   *
   *  If `true` validates that the given value is not empty, if `false`, validates that the given value is empty.
   *
   *  ## Examples
   *
   *  ```javascript
   *  validator('presence', true)
   *  validator('presence', false)
   *  validator('presence', {
   *    presence: true,
   *    message: 'should not be empty'
   *  })
   *
   *  validator('presence', {
   *    presence: true,
   *    ignoreBlank: true,
   *    message: 'should not be empty or consist only of spaces'
   *  })
   *  ```
   *
   *  @class Presence
   *  @module Validators
   *  @extends Base
   */
  var _default = _exports.default = _emberValidator.default.extend({
    _evType: 'presence',
    /**
     * Normalized options passed in.
     * ```js
     * validator('presence', true)
     * // Becomes
     * validator('presence', {
     *   presence: true
     * })
     * ```
     *
     * @method buildOptions
     * @param  {Object}     options
     * @param  {Object}     defaultOptions
     * @param  {Object}     globalOptions
     * @return {Object}
     */
    buildOptions() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let defaultOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let globalOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      let opts = options;
      if (typeof options === 'boolean') {
        opts = {
          presence: options
        };
      }
      return this._super(opts, defaultOptions, globalOptions);
    }
  });
});